<template>
  <Layout>
      <wizard></wizard>
  </Layout>
</template>

<script setup lang="ts">
import Layout from "./Layout.vue";
import wizard from "@/components/school/wizard/wizard.vue";
//
</script>

<style scoped lang="scss">
@use "@/assets/_vars.scss" as *;
@use "@/assets/_breakpoints.scss" as breakpoints;


</style>
